import React, { Component, Fragment } from 'react';
import './WebsiteFooter.module.scss';
import {connect} from 'react-redux';

import indexPartner from 'actions/partner/index';
import Partner from './Partner/Partner';

const mapStateToProps = (state, props) => {
    return {
        blocks: state.block.entities,
        partners: state.partner.entities,
    };
};

const mapDispatchToProps = {
    indexPartner
};



class WebsiteFooter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hover: false,
        }
    }
    componentDidMount(){
        this.props.indexPartner()
    }

    render() {
        return (
            <Fragment>
                <div styleName='footer'>
                    <div styleName='title'></div>
                    <p>Partners</p>
                    {
                        this.props.partners.allIds.map(function(partnerId, i){
                            let item = this.props.partners.byId[partnerId];
                            return(
                                <Partner item={item} />
                            );
                        }, this)
                    }
                </div>
                <div styleName='extra-footer1'>
                    <img styleName='blue' src='/images/footer/stain-blue.svg'></img>
                    <p styleName='text-blue'>
                        MU Hybrid Art House is een huis voor hybride kunst in Eindhoven (Strijp-S),
                        waarin de kunst letterlijk en figuurlijk centraal staat.
                        MU onderzoekt met haar kunstenaars en publiek wat kunst zou kunnen zijn.  
                    </p>
                    {/* <img styleName='yellow' src='/images/footer/stain-yellow.svg'></img> */}
                    <p styleName='text-yellow'>
                        Torenallee 40-06<br></br>
                        5617 BD Eindhoven<br></br>
                        The Netherlands<br></br>
                        decreatievecode@mu.nl<br></br>
                        <a href="mu.nl">www.mu.nl</a><br></br>
                        T +31 40 296 1663<br></br>
                    </p>
                </div>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WebsiteFooter);